import React from 'react';
import {withRouter} from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/fr';
import {fastapi} from 'api';
import {Buttons, Structure, Typography} from 'components';
import {SubStepAccounts, SubStepDocuments, SubStepProfile} from './components';
import {useUser} from 'hooks';

import {makeStyles} from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(2, 0)
    },
    title: {
        paddingBottom: theme.spacing(2)
    },
    previous: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%'
        }
    }
}));

function TransferAIS({history}) {
    const classes = useStyles();

    const {user} = useUser();
    const accountsScopes = user.scopes.filter((scope) => ['ais', 's2e'].includes(scope));

    return (
        <>
            <Typography
                className={classes.title}
                variant="h3"
                color="blue"
                semibold
                caps
            >
                Demande de transfert vers votre Epargne retraite
            </Typography>

            <Structure.Stepper
                firstAction={
                    <Buttons.Default
                        className={classes.previous}
                        label="Précédent"
                        color="blueAlpha"
                        previous
                        onClick={() => {
                            const previousUrl = accountsScopes.length === 2 ? '/savings/transfer' : '/epargne';
                            history.push(previousUrl);
                        }}
                    />
                }
                lastAction={
                    <Buttons.Default
                        label="Signer électroniquement"
                        color="orange"
                        next
                    />
                }
                variant="blue"
            >
                <SubStepProfile
                    values={user.ais_profile}
                    schema={{
                        last_name: {
                            presence: {
                                allowEmpty: false,
                                message: 'Veuillez renseigner votre nom'
                            }
                        },
                        first_name: {
                            presence: {
                                allowEmpty: false,
                                message: 'Veuillez renseigner votre prénom'
                            }
                        },
                        street_line: {
                            presence: {
                                allowEmpty: false,
                                message: 'Veuillez renseigner votre adresse'
                            }
                        },
                        zip_postal_code: {
                            presence: {
                                allowEmpty: false,
                                message: 'Veuillez renseigner votre code postal'
                            }
                        },
                        locality: {
                            presence: {
                                allowEmpty: false,
                                message: 'Veuillez renseigner votre ville'
                            }
                        },
                        mobile: {
                            presence: {
                                allowEmpty: false,
                                message: 'Veuillez renseigner votre numéro de téléphone'
                            },
                            numericality: true
                        },
                        email: {
                            presence: {
                                allowEmpty: false,
                                message: 'Veuillez renseigner votre email'
                            },
                            email: {message: "Votre email n'est pas valide"}
                        }
                    }}
                />
                <SubStepAccounts
                    schema={{
                        origin_contract_number: {
                            presence: {
                                allowEmpty: false,
                                message: 'Veuillez renseigner le numéro du contrat à transférer'
                            }
                        },
                        company_name: {
                            presence: {
                                allowEmpty: false,
                                message: "Veuillez renseigner le nom de l'entreprise du compte origine"
                            }
                        },
                        insurer_name: {
                            presence: {
                                allowEmpty: false,
                                message: "Veuillez renseigner le nom de l'assureur"
                            }
                        },
                        insurer_street_line: {
                            presence: {
                                allowEmpty: false,
                                message: "Veuillez renseigner l'adresse de l'assureur"
                            }
                        },
                        insurer_zip_postal_code: {
                            presence: {
                                allowEmpty: false,
                                message: "Veuillez renseigner le code postal de l'assureur"
                            }
                        },
                        insurer_locality: {
                            presence: {
                                allowEmpty: false,
                                message: "Veuillez renseigner la ville de l'assureur"
                            }
                        },
                        insurer_mobile: {
                            presence: {
                                allowEmpty: false,
                                message: "Veuillez renseigner le n° de téléphone de l'assureur"
                            }
                        },
                        insurer_email: {
                            presence: {
                                allowEmpty: false,
                                message: "Veuillez renseigner l'adresse e-mail de l'assureur"
                            },
                            email: {
                                message: "L'email de l'assureur n'est pas valide"
                            }
                        },
                        receiver_contract_number: {},
                        receiver_company: {}
                    }}
                />
                <SubStepDocuments
                    schema={{
                        passport: {
                            presence: {
                                allowEmpty: false,
                                message: 'Document obligatoire'
                            }
                        },
                        last_account_situation: {
                            presence: {
                                allowEmpty: false,
                                message: 'Document obligatoire'
                            }
                        }
                    }}
                    submit={(stepper) =>
                        fastapi
                            .post('services/esign/transfer/ais', {
                                files: {
                                    passport: stepper.payload.passport,
                                    last_account_situation: stepper.payload.last_account_situation,
                                    termination_employment_contract: stepper.payload.termination_employment_contract
                                },
                                properties: {
                                    ...stepper.payload,
                                    date: moment(new Date()).format('DD MMMM YYYY')
                                }
                            })
                            .then((response) => (window.location.href = response.data))
                    }
                />
            </Structure.Stepper>
        </>
    );
}

export default withRouter(TransferAIS);
